import ReactDOM from "react-dom/client";
import React from "react";
import ProductDescriptionDetailModal from "./components/ProductDescriptionDetailModal";
import ProductDetailPageTypeConfig from "./ProductDetailPageTypeConfig";

export default new class DescriptionDetailModalService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig): void {
        for (const showDescriptionDetailButton of document.querySelectorAll<HTMLSpanElement>(".js-description-detail-modal")) {
            showDescriptionDetailButton.addEventListener("click", (event: MouseEvent): void => {
                event.preventDefault();
                this.showDescriptionDetailModal(pageTypeConfig);
            });
        }
    }

    public showDescriptionDetailModal(pageTypeConfig: ProductDetailPageTypeConfig): void {
        const containerElement = document.createElement("div");
        const productDetailInfo = pageTypeConfig.products[0];
        const root = ReactDOM.createRoot(containerElement);

        root.render(<ProductDescriptionDetailModal
            productDetailInfo={productDetailInfo}
            onAfterClose={(): void => {
                root.unmount();
                containerElement.remove();
            }}
        />);
    }
}();
